import Component from '@glimmer/component';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import Icon from './icon.gjs';
import { faEllipsis } from '../icons/solid.js';

class ContextMenuItem extends Component {
  @action onClick() {
    document.activeElement.blur();
    this.args.action();
  }

  <template>
    <li>
      <a {{on "click" this.onClick}}>
        {{#if (has-block)}}
          {{yield}}
        {{else}}
          {{@label}}
        {{/if}}
      </a>
    </li>
  </template>
}

<template>
  <div class="dropdown" ...attributes>
    <div tabindex="0" role="button" class="btn btn-ghost btn-square btn-sm">
      <Icon @icon={{faEllipsis}} />
    </div>
    <ul
      tabindex="0"
      class="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm"
    >
      {{yield (component ContextMenuItem)}}
    </ul>
  </div>
</template>

